export default "__VITE_PUBLIC_ASSET__47b031a8__"